import React from "react";
import { useRouter } from "next/router";
interface KYCBackButtonWithListingIdProps {
  bidderAuctionId: any;
}
export default function KYCBackButtonWithListingId({
  bidderAuctionId,
}: KYCBackButtonWithListingIdProps) {
  const router = useRouter();
  const handleBackClick = () => {
    router.replace("/");
  };
  return (
    <div className="mb-5 flex gap-2 justify-between bg-white p-2">
      <button
        onClick={handleBackClick}
        className="inline-flex items-center gap-2 bg-white text-sm font-medium text-brand-textLightGrey hover:border-brand-orange hover:text-brand-orange"
      >
        <span className="text-base leading-none">&larr;</span>
        <span>Back</span>
      </button>
      <div className="inline-flex items-center gap-2 rounded-full text-sm font-medium text-brand-textGrey">
        <span className="tracking-wide text-brand-orange">ID :</span>
        <span className="text-brand-orange">{bidderAuctionId ?? "-"}</span>
      </div>
    </div>
  );
}
